import { Injectable } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private activeTooltip: Tooltip | null = null;

  activateTooltip(tooltip: Tooltip): void {
    if (this.activeTooltip && this.activeTooltip !== tooltip) {
      this.activeTooltip.deactivate();
    }
    this.activeTooltip = tooltip;
    this.activeTooltip.activate();
  }

  deactivateTooltip(tooltip: Tooltip): void {
    if (this.activeTooltip === tooltip) {
      this.activeTooltip.deactivate();
      this.activeTooltip = null;
    }
  }
}
